import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "en",
  supportedLngs: ["en", "es"],
  resources: {
    en: {
      translations: require("./en/translations.json"),
    },
    es: {
      translations: require("./es/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

export default i18n;
